import { useEffect, useRef } from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import { environment } from "../../environment/environment";

export const useMapMarker = (mapClicked, handleFormData) => {
  const { isLoaded: isMapLoaded } = useJsApiLoader({
    googleMapsApiKey: environment.googleMapsApiKey,
    libraries: ["places"]
  });
  const geocoderRef = useRef(null);

  const handleMarker = (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();

    mapClicked.current = true;
    getAddressFromLatLng(lat, lng);
  };

  const getAddressFromLatLng = (lat, lng) => {
    if (!geocoderRef.current) return;

    geocoderRef.current.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results[0]) {
        handleFormData({
          formatted_address: results[0].formatted_address,
          coordinates: { lat, lng }
        });

        setTimeout(() => {
          mapClicked.current = false;
        }, 300);
      }
    });
  };

  useEffect(() => {
    if (isMapLoaded) geocoderRef.current = new window.google.maps.Geocoder();
  }, [isMapLoaded]);

  return {
    isMapLoaded,
    geocoderRef,
    handleMarker
  };
};